import React from 'react';
import { WebsiteImage } from 'components/TitleDescription';
import { STLogoTertiary } from 'components/Brand/Logos/STLogo';
import CardsBodyWrapper from '../CardsBodyWrapper';
import { ComparisonContainer } from './styles';

const ComparisonCard = props => {
  const { company, companyLogo } = props;

  return (
    <div
      data-testid="comparison-card-body-wrapper"
      role="listitem"
      className="card--body-wrapper icon-card--body-wrapper"
    >
      <ComparisonContainer className="comparison-card--main-container">
        <div data-testid="comparison-card-main-logo" className="comparison-card--main-logo">
          <STLogoTertiary />
        </div>
        <h2 className="comparison-card--vs-text">VS</h2>
        <div data-testid="comparison-card-other-logo" className="comparison-card--other-logo">
          {companyLogo ? <WebsiteImage src={companyLogo} /> : <p>{company || ''}</p>}
        </div>
      </ComparisonContainer>
    </div>
  );
};

export default CardsBodyWrapper(ComparisonCard);
